var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBubbleWhite = function SvgBubbleWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 457,
    viewBox: "0 0 380 457",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 318.565L0 0H380V319.131L251.187 319.145V457L0 318.565Z",
    fill: "white"
  })));
};
export default SvgBubbleWhite;